import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

export interface IDropOption {
  title: string;
  id: any;
  extra?: string;
}

import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import {
  FormControl,
  FormControlName,
  ReactiveFormsModule,
} from '@angular/forms';

@Component({
  selector: 'app-phil-dropdown',
  imports: [MatAutocompleteModule, ReactiveFormsModule],
  templateUrl: './phil-dropdown.component.html',
  styleUrls: ['./phil-dropdown.component.scss'],
  standalone: true,
})
export class PhilDropdownComponent {
  @Input() options!: IDropOption[];
  @Input() control?: FormControl;
  @Input() placeholder: string = '';

  @Input() isSelectEmit: boolean = false;
  @Output() optionSelected = new EventEmitter<string>();
  @Input() isSelectEmitTitle: boolean = false;
  @Output() titleSelected = new EventEmitter<string>();
  @Input() isKeyUp: boolean = false;
  @Output() onKeyUp = new EventEmitter<KeyboardEvent>();

  @Input() isAutoFocus: boolean = false;
  @Input() isInputTextControl: boolean = false;

  @Input() isNotEditable: boolean = false;
  @Input() showError: boolean = false;
  @Input() errorMessage!: string;
  @Input() isTransparent: boolean = false;

  @Output() optionClicked = new EventEmitter<string>();

  tempOptions: any;
  filteredOptions: any = [];
  isError: boolean = false;

  constructor() { }

  ngOnInit() {
    if (!this.isInputTextControl) {
      this.control?.valueChanges.subscribe((data) => {
        const selected = this.options.find(
          (opt) => String(opt.id).toLowerCase() === String(data).toLowerCase()
        );
        if (selected) this.inputElement.nativeElement.value = selected?.title;
        else this.inputElement.nativeElement.value = '';
      });
    }
    this.filteredOptions = this.options;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.filteredOptions = changes['options'].currentValue;

      if (this.control?.value) {
        const selected = this.options.find(
          (opt) =>
            String(opt.id).toLowerCase() ===
            String(this.control?.value).toLowerCase()
        );
        if (this.inputElement?.nativeElement) {
          if (selected) {
            this.inputElement.nativeElement.value = selected.title;
          } else {
            this.inputElement.nativeElement.value = '';
          }
        }
      }
    }
  }

  @ViewChild('dropInput') inputElement!: ElementRef;

  ngAfterViewInit() {
    if (this.isAutoFocus)
      setTimeout(() => this.inputElement.nativeElement.focus());
    if (this.control?.value) {
      const selected = this.options?.find(
        (opt) =>
          String(opt.id).toLowerCase() ===
          String(this.control?.value).toLowerCase()
      );
      if (selected) this.inputElement.nativeElement.value = selected?.title;
    }
  }

  filterOptions(val: string | null) {
    if (!this.isInputTextControl) {
      if (val && val.length > 0) {
        this.filteredOptions = this.options.filter((opt) =>
          opt.title.toLowerCase().includes(val.toLowerCase())
        );
      } else {
        this.filteredOptions = this.options;
        if (this.isSelectEmit) {
          this.optionSelected.emit('');
        }
        if (this.control) {
          this.control.setValue('');
        }
      }
    }
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    if (this.isSelectEmit) {
      const selected = this.options.find(
        (opt) =>
          String(opt.title).toLowerCase() ===
          String(event.option.value).toLowerCase()
      );
      this.optionSelected.emit(selected?.id);
    }
    if (this.isSelectEmitTitle) {
      const title = event.option.value;
      this.titleSelected.emit(title);
    }
    if (this.isSelectEmit && !this.isInputTextControl)
      if (this.control) {
        const selectedOption = this.options.find(
          (opt) =>
            String(opt.title).toLowerCase() ===
            String(event.option.value).toLowerCase()
        );
        this.control.setValue(selectedOption?.id);
      }
  }

  onClick(id: string) {
    this.optionClicked.emit(id);
  }

  getFormControl() {
    return this.control as FormControl;
  }

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger;
  openFocus() {
    if (!this.isNotEditable) this.autocompleteTrigger.openPanel();
  }

  closeFocus() {
    this.autocompleteTrigger.closePanel();
  }

  onClickKeyUp(event: KeyboardEvent) {
    if (this.isKeyUp) this.onKeyUp.emit(event);
  }

  checkValid() {
    if (!this.control?.valid) this.isError = true;
    else if (!this.control.value) this.isError = true;
    else this.isError = false;
  }
}
